import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  uploadsTempContainer: [],
  fileUploadStatus: IDLE,

  fileUploadMessageAttachmentStatus: IDLE
};

const fileUploadSlice = createSlice({
  name: 'fileUpload',
  initialState,
  reducers: {
    uploadFile(state) {
      state.fileUploadStatus = LOADING;
    },
    uploadFileSucceeded(state, action) {
      state.uploadsTempContainer.push(action.payload);
      state.fileUploadStatus = SUCCEEDED;
    },
    uploadFileFailed(state) {
      state.fileUploadStatus = FAILED;
    },

    uploadFileMessageAttachment(state) {
      state.fileUploadMessageAttachmentStatus = LOADING;
    },
    uploadFileMessageAttachmentSucceeded(state) {
      state.fileUploadMessageAttachmentStatus = SUCCEEDED;
    },
    uploadFileMessageAttachmentFailed(state) {
      state.fileUploadMessageAttachmentStatus = FAILED;
    },

    clearUploadsTempContainer(state) {
      state.uploadsTempContainer = [];
      state.fileUploadStatus = IDLE;
      state.fileUploadMessageAttachmentStatus = IDLE;
    }
  }
});

export const {
  uploadFile,
  uploadFileSucceeded,
  uploadFileFailed,

  uploadFileMessageAttachment,
  uploadFileMessageAttachmentSucceeded,
  uploadFileMessageAttachmentFailed,

  clearUploadsTempContainer
} = fileUploadSlice.actions;

export default fileUploadSlice.reducer;
